import React from 'react';
import { BoxArrowUpRightIcon } from '@onsolve/onsolve-ui-components';

import { coreTranslations } from 'translations';
import {
    AnnouncementsImage,
    DocumentationImage,
    ResourceLibraryImage,
    SupportImage,
} from '@components/GlobalSearch/Images/index';
import isMobileAppView from 'common/utility/isMobileAppView';
import supportCommunityService from '@components/GlobalSearch/Services/SupportCommunityService/supportCommunity.service';
import featureService from '@services/feature.service';

function openUrl(url) {
    if (typeof url !== 'string') {
        console.error("url is not a string")
    }
    const otherWindow = window.open();
    if (otherWindow) {
        otherWindow.opener = null;
        otherWindow.location = url;
    }
}


export const tilesConfig = [
    {
        title: coreTranslations.ng_core_contactUs,
        description: coreTranslations.ng_core_contactSupportTileDescription,
        icon: <SupportImage color="primary" />,
        visible: () => true,
        path: '/contact-us'
    },
    {
        title: coreTranslations.ng_core_onsolveAnnouncements,
        description: coreTranslations.ng_core_announcementsDescription,
        icon: <AnnouncementsImage color="primary" />,
        visible: access => access.canViewAnnouncements(),
        path: '/announcements-inbox'
    },
    {
        title: coreTranslations.ng_core_documentation,
        description: coreTranslations.ng_core_documentationDescription,
        icon: <DocumentationImage color="primary" />,
        path: '/documentation',
        visible: () => featureService.getFeature('supportTrainingDocumentation')
    },
    {
        title: coreTranslations.ng_core_resourceLibrary,
        description: coreTranslations.ng_core_resourceLibraryDescription,
        icon: <ResourceLibraryImage color="primary" />,
        buttonIcon: <BoxArrowUpRightIcon color="primary" />,
        onClick: e => {
            e.preventDefault();
            supportCommunityService.getLoginUrl().then(openUrl);
        },
        visible: () => featureService.getFeature('resourceLibraryPage') && !isMobileAppView()
    },
    {
        title: coreTranslations.ng_core_announcementInternalTool,
        description: coreTranslations.ng_core_announcementInternalToolDescription,
        visible: access => access.canViewAnnouncementsTool(),
        path: '/announcements-tool'
    }
];
